import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const IllustrationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${Spacing.S16};
`
